import Head from 'next/head';

import { applicationSettings } from '@/constants';
import AllListings from '@/components/AllListings';
import ArticleCards from '@/components/ArticleCards';
import ArticleCardsWithImage from '@/components/ArticleCardsWithImage';
import ResultsListings from '@/components/ResultsListings';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import HeroCategory from '@/components/HeroCategory';
import { CategoryCopy, hasAdditionalContent } from '@/components/CategoryCopy';
import { getArticlesByPage, getDailyCount } from '@/helpers/helpers_data';
import { prettifyCity } from '@/helpers/helpers';
import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

const { CALLAPRO_WEBSITE_URL } = applicationSettings;

const ARTICLES_PER_PAGE = 10;

export async function getServerSideProps(context) {
  const category = CATEGORY_SUBSETS.find((category) => category.url_slug === context.params.category);
  const categoryId = category?.id;
  // Need to convert the category url_slug into the friend name to retrieve articles from the blog API.
  const categoryName = category?.name;
  const articlesCategoryName = category?.articles_category_name;

  const data = await getArticlesByPage({
    limit: ARTICLES_PER_PAGE,
    category: articlesCategoryName || categoryName
  });
  const daily_count = categoryId ? await getDailyCount(categoryId.toString()) : undefined;

  return {
    props: {
      state: context.params.state,
      city: context.params.city,
      category,
      articles: data.articles,
      total_articles: data.total,
      daily_count: daily_count
    }
  };
}

const Category = (props) => {
  return (
    <div className="page-wrapper">
      <Head>
        <title>{`${props.category?.meta?.category_name} in ${prettifyCity(props.city)}, ${props.state.toUpperCase()}` || 'Find Home Service Pros Near You'}</title>

        <meta name="description" content={props.category?.meta?.description || 'CallAPro - Find a Home Service Professional Near You'} />

        {props.category?.meta?.keywords && <meta name="keywords" content={props.category?.meta.keywords} />}
        {props.category?.meta?.og_description && <meta name="og:description" content={props.category?.meta.og_description} />}
        {props.category?.meta?.og_title && <meta name="og:title" content={props.category?.meta.og_title} />}
        {props.category?.meta?.og_url && <meta name="og:url" content={props.category?.meta.og_url} />}

        <link rel="canonical" href={props.category?.meta?.canonical || `${CALLAPRO_WEBSITE_URL}/${props.category.url_slug}/`} />
      </Head>
      <Header type="category" />

      <HeroCategory {...props} />

      <ResultsListings {...props} />

      {hasAdditionalContent(props.category.url_slug) && <CategoryCopy slug={props.category.url_slug} />}

      <AllListings {...props} />

      {props.articles.length > 0 && <ArticleCardsWithImage articles={props.articles.slice(0, 3)} headline={`Recent ${props.category.name_singular} Articles`} />}
      {props.articles.length > 3 && <ArticleCards articles={props.articles.slice(3, 10)} headline={`More ${props.category.name_singular} Articles`} />}

      <Footer />
    </div>
  );
};

export default Category;
